import { Button, Form } from "react-bootstrap";
import FormRow from "./uiElements/FromRow.component";
import { useForm } from "react-hook-form";
import { useScale } from "../hooks/useScale";

function Scaling({ onCloseModal, tradeId, ticker, type, scaleToEdit }) {
  const isEditSession = Boolean(scaleToEdit);
  const { formState, handleSubmit, register } = useForm({
    defaultValues: isEditSession
      ? {
          ...scaleToEdit,
          date: scaleToEdit?.date?.split("T")[0],
        }
      : {},
  });

  const { errors } = formState;

  const { isLoading, scaleIn, scaleOut, editScaleIn, editScaleOut } = useScale();

  const onSubmit = (data) => {
    if (type === "Scale In") {
      scaleIn(
        { ...data, tradeId },
        {
          onSuccess: () => {
            onCloseModal();
          },
        }
      );
    } else if (type === "Scale Out") {
      scaleOut(
        { ...data, tradeId },
        {
          onSuccess: () => {
            onCloseModal();
          },
        }
      );
    } else if (type === "Edit scale in") {
      editScaleIn(
        { ...data, tradeId },
        {
          onSuccess: () => {
            onCloseModal();
          },
        }
      );
    } else if (type === "Edit scale out") {
      editScaleOut(
        { ...data, tradeId },
        {
          onSuccess: () => {
            onCloseModal();
          },
        }
      );
    }
    console.log(data);
  };

  return (
    <div>
      <form className="scale-form" onSubmit={handleSubmit(onSubmit)}>
        <h3>
          {type} ( {ticker} )
        </h3>
        <hr />
        <FormRow label="Price" error={errors?.price?.message}>
          <Form.Control
            step="any"
            type="text"
            id="price"
            placeholder="Enter Price"
            {...register("price", {
              required: "This field is required",
              valueAsNumber: true,
              min: {
                value: 0.1,
                message: "Price must be at least 0.1",
              },
            })}
          />
        </FormRow>
        <FormRow label="Quantity" error={errors?.quantity?.message}>
          <Form.Control
            step="any"
            type="number"
            id="quantity"
            placeholder="Enter ticker"
            {...register("quantity", {
              required: "This field is required",
              valueAsNumber: true,
              min: {
                value: 1,
                message: "Quantity must be at least 1",
              },
            })}
          />
        </FormRow>
        <FormRow label="Date" error={errors?.date?.message}>
          <Form.Control
            type="date"
            id="date"
            placeholder="Enter ticker"
            {...register("date", {
              required: "This field is required",
              valueAsDate: true,
            })}
          />
        </FormRow>
        <div className="w-100 trade-btn">
          <Button onClick={onCloseModal} className="trade-btn" variant="outline-danger">
            Cancel
          </Button>
          <Button type="submit" className="trade-btn" variant="success" disabled={isLoading}>
            {isLoading ? "SUBMIT..." : `${type}`}
          </Button>
        </div>
      </form>
    </div>
  );
}

export default Scaling;
